import React from 'react'
import MetaTags from 'react-meta-tags'
import {selectEntryTopicTitles} from '../../../../redux/modules/entryTopicTitles'
import {connect} from 'react-redux'
import SubjectsContainer from '../components/SubjectsContainer'
import VisibleSearchHeader from './VisibleSearchHeader'
import {toJS} from '../../../../util/ToJS'
import {withNav} from '../../../../core/components/navbar/index'
import '../components/subjects.css'


class VisibleSubjects extends React.PureComponent {
  render() {
    return (
      <div className='subjects__page-container'>
        <MetaTags>
          <title>Expii - Learn Creatively</title>
          <meta name="og:title" content="Expii - Learn Creatively" />
          <meta name="description" content="Expii is a free personalized learning website with thousands of math and science lessons, providing diverse ways to learn each topic, through interactive explanations and video." />
          <meta name="og:description" content="Expii is a free personalized learning website with thousands of math and science lessons, providing diverse ways to learn each topic, through interactive explanations and video." />
        </MetaTags>
        
        <VisibleSearchHeader />
        <SubjectsContainer {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  titles:selectEntryTopicTitles(state)
})

export default connect(
  mapStateToProps
)(toJS(withNav(VisibleSubjects)))



// WEBPACK FOOTER //
// ./src/domains/home/subjects/containers/VisibleSubjects.js